<template>
  <div ref="stage" class="mbo-stage">
    <div class="mbo-stage__canvas" :style="{transform: `scale(${scale})`}">
      <slot/>
    </div>
  </div>
</template>

<script>
import {OVERLAY_WIDTH} from '@/common/mlbbOverlay'

// Вписывает холст 1920×1080 в ширину контейнера (превью и монитор эфира)
export default {
  name: 'MbOverlayStage',
  data() {
    return {scale: 0}
  },
  mounted() {
    this.fit()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.fit())
      this.observer.observe(this.$refs.stage)
    } else {
      window.addEventListener('resize', this.fit)
    }
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    else window.removeEventListener('resize', this.fit)
  },
  methods: {
    fit() {
      const width = this.$refs.stage?.clientWidth || 0
      this.scale = width / OVERLAY_WIDTH
    },
  },
}
</script>
